const ITEMS = [
  "WOMEN-FOUNDED",
  "TRUSTED ALLIES",
  "COMPASSIONATE GUIDANCE",
  "CONNECTED ACROSS 24 STATES",
  "EMPOWERING VICTIMS",
  "TOP LITIGATION COUNSEL",
  "CERTIFIED COLLISION CRAFTSMEN",
  "SAME-DAY RENTALS & TOWING",
];

const Row = () => (
  <div className="flex items-center shrink-0">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center shrink-0">
        <span className="font-display text-sm sm:text-base font-semibold tracking-[0.22em] text-[#D6D0C4] px-8">
          {item}
        </span>
        <span className="w-2 h-2 rotate-45 bg-[#C9A24B] shrink-0" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee-strip"
    className="py-5 border-y border-[#C9A24B]/20 bg-[#071A2B] overflow-hidden"
  >
    <div className="marquee-track">
      <Row />
      <Row />
    </div>
  </div>
);
